export default __webpack_public_path__ + "static/media/img3.13dc6040.jpg";